module.exports = __webpack_public_path__ + "assets/img/28fb4bbfdd864459ddfd23e22e2d16ec.jpg";